import React, { useMemo, useState, useEffect } from "react";

import { connect } from "react-redux";
import styled from "styled-components";

import { getReferencesForReports } from "actions/references";
import { servicePick, removeNilValues, compareTwoArrays } from "utils";
import FormHOC from "hoc/FilltersForm";
import { toUTCDateTime } from "utils";
import DateTimeRangePicker from "components/DateRangePicker/DateTimerRangePicker";
import { ButtonPrimary } from "components/base/BaseButton";
import CustomField from "components/Form/CustomField";
import Text from "components/Form/Text";

import { Checkbox, CheckPicker, Form, Input, SelectPicker } from "rsuite";

// const { allowedRange } = DateRangePicker;


const CDRFilters = ({
    onApplyFilters,
    preFilters,
    setPreFilters,
    defaultFilters,
    loading,
    globalSettings = {},
    isFailedMdr,
    service,
    ...props
}) => {

    const isFailedMdrDefaultValues = {
        ...defaultFilters,
        operator: null,
        cntr_key_list: [],
        supplier_id_list: [],
        supplier_trunk_id_list: [],
        senderid: null,
        mcc_mnc: null,
        sender_sde_key_list: [],
        phone_sde_key_list: [],
        phone: null,
        reason_list: []
    };

    const trafficMdrDefaultValues = {
        ...defaultFilters,
        ...(!service ? { operator: null, cntr_key_list: [] } : {}),
        ...(!service ? { message_id: null } : {}),
        ...(!service ? {
            supplier_id_list: [],
            supplier_trunk_id_list: [],
        } : {}),
        dialer_id_list: [],
        ...(servicePick(service, { originator_key_list: [] }, { originator_name: null })),
        [servicePick(service, "a_sde_key_list", "sender_sde_key_list")]: null,
        [servicePick(service, "b_sde_key_list", "phone_sde_key_list")]: null,
        [servicePick(service, "a_number", "senderid")]: null,
        [servicePick(service, "b_number", "phone")]: null,
        ...(service ? {} : { mcc_mnc: null })
    };

    const [filters, setFilters] = useState(defaultFilters);
    const [secondUpdateFixer, setSecondUpdateFixer] = useState(null);
    const [onlyMyAccountCheck, setOnlyMyAccountCheck] = useState(true);

    const [currentFilters, setCurrentFilters] = useState(<></>);
    const [pickedSupplier, setPickedSupplier] = useState(null);
    const [pickedSupplierTrunkList, setPickedSupplierTrunkList] = useState([]);

    useEffect(() => {
        const deafultFilterValues = isFailedMdr ? isFailedMdrDefaultValues : trafficMdrDefaultValues;

        setFilters(deafultFilterValues);

        const preDeafultFilterValues = { ...deafultFilterValues };

        if (preDeafultFilterValues.range && preDeafultFilterValues.range.length) {
            // filterValues["start_date"] = toStartDayUTCTime(filterValues.range[0]);
            // filterValues["end_date"] = toEndDayUTCTime(filterValues.range[1]);
            preDeafultFilterValues["start_date"] = toUTCDateTime(preDeafultFilterValues.range[0]);
            preDeafultFilterValues["end_date"] = toUTCDateTime(preDeafultFilterValues.range[1]);

            delete preDeafultFilterValues.range;
        }
        setPreFilters(removeNilValues(preDeafultFilterValues))

        setOnlyMyAccountCheck(true);

        setSecondUpdateFixer(null);
    }, [isFailedMdr])

    const reasonList = props.reasonList ? props.reasonList.map((reason, idx) => { return { name: reason, key: reason } }) : [];

    const handleChangeDateTime = (value) => {
        const filter = { ...value };
        const currentDatetimeFilter = { range: [filter.range[0], filter.range[1]] };

        const filtersToUpdate = {
            ...filters,
            ...filter,
            ...currentDatetimeFilter
        };

        setFilters(filtersToUpdate);

        const filterValues = { ...filtersToUpdate };

        if (filterValues.range && filterValues.range.length) {
            // filterValues["start_date"] = toStartDayUTCTime(filterValues.range[0]);
            // filterValues["end_date"] = toEndDayUTCTime(filterValues.range[1]);
            filterValues["start_date"] = toUTCDateTime(filterValues.range[0]);
            filterValues["end_date"] = toUTCDateTime(filterValues.range[1]);

            delete filterValues.range;
        }

        setPreFilters(removeNilValues(filterValues))
    };

    const handleChange = (formValues) => {
        if (!service && (
            formValues["supplier_id_list"] === null ||
            !compareTwoArrays(formValues["supplier_id_list"], filters["supplier_id_list"]) ||
            formValues["supplier_id_list"] && formValues["supplier_id_list"].length === 0 ||
            formValues["supplier_id_list"] && formValues["supplier_id_list"].length > 1
        )) {
            if ("supplier_trunk_id_list" in formValues) {
                delete formValues.supplier_trunk_id_list;
                setPickedSupplierTrunkList([]);
            }
        }

        setFilters(formValues);

        const filterValues = { ...formValues };

        if (filterValues.range && filterValues.range.length) {
            // filterValues["start_date"] = toStartDayUTCTime(filterValues.range[0]);
            // filterValues["end_date"] = toEndDayUTCTime(filterValues.range[1]);
            filterValues["start_date"] = toUTCDateTime(filterValues.range[0]);
            filterValues["end_date"] = toUTCDateTime(filterValues.range[1]);

            delete filterValues.range;
        }

        setPreFilters(removeNilValues(filterValues))
    };

    const handleApply = () => {

        onApplyFilters(removeNilValues(preFilters));
    };

    const checkOnlyAccount = (checked) => {
        setFilters((value) => {
            return {
                ...value,
                only_my_account: checked
            }
        });
        setPreFilters((preValue) => {
            return {
                ...preValue,
                only_my_account: checked
            }
        });
        setOnlyMyAccountCheck(checked);
    };

    const checkReliability = (name, checked) => {
        setFilters((value) => ({ ...value, [name]: checked }));
        setPreFilters((value) => ({ ...value, [name]: checked }));
    };

    useEffect(() => {
        props.getReferencesForReports();
    }, []);

    useEffect(() => {
        const cdrMdrFilters = <>
            <DateTimeRangePicker
                onChange={(value) => {
                    handleChangeDateTime(value);
                }}
                defaultStartDate={defaultFilters?.range[0]}
                defaultEndDate={defaultFilters?.range[1]}
                startDate={filters.range[0]}
                endDate={filters.range[1]}
                showRanges
            // input={false}
            />
            {service ? <CustomField
                accepter={CheckPicker}
                virtualized
                labelKey="name"
                valueKey="acc_key"
                data={props.originatorList}
                placeholder="Originators"
                name="originator_key_list"
                width={200}
                menuStyle={{
                    width: 280
                }}
            />
                : <Text
                    name="originator_name"
                    placeholder="Originator"
                    width={200}
                />}

            {!service ? <Text
                name="operator"
                placeholder="Operator"
                width={150}
                value={filters.operator}
            /> : <></>}
            {!service ? <CustomField
                accepter={CheckPicker}
                labelKey="name"
                valueKey="cntr_key"
                data={props.countryList}
                placeholder="Countries"
                name="cntr_key_list"
                width={200}
                menuStyle={{
                    width: 280
                }}
            /> : <></>}
            {!service ? <CustomField
                accepter={CheckPicker}
                virtualized
                data={props.supplierList}
                onChange={(supplierIdList) => {
                    if (supplierIdList && supplierIdList.length === 1) {
                        const foundSupplier = props.supplierList.find(supplier => supplier.id === supplierIdList[0]);
                        setPickedSupplier(foundSupplier || null);
                    } else {

                        setPickedSupplier(null);
                    }
                }}
                labelKey="name"
                valueKey="id"
                placeholder="Suppliers"
                name="supplier_id_list"
                width={200}
                menuStyle={{
                    width: 320
                }}
            /> : <></>}
            {!service ? <CustomField
                accepter={CheckPicker}
                data={pickedSupplier?.supplier_trunk_list || []}
                virtualized
                onChange={(supplierTrunkIdList) => {
                    setPickedSupplierTrunkList(supplierTrunkIdList);
                }}
                value={pickedSupplierTrunkList}
                labelKey="name"
                valueKey="id"
                placeholder="Supplier trunks"
                name="supplier_trunk_id_list"
                width={200}
                searchable={false}
                disabled={!pickedSupplier}
            /> : <></>}
            <CustomField
                accepter={CheckPicker}
                virtualized
                data={props.dialerList}
                labelKey="name"
                valueKey="id"
                placeholder="Dialers"
                name="dialer_id_list"
                width={200}
                menuStyle={{
                    width: 320
                }}
            />
            <CustomField
                accepter={CheckPicker}
                width={300}
                data={props.subdestinationList}
                virtualized
                labelKey="name"
                valueKey="sde_key"
                placeholder="Origins"
                name={servicePick(service, "a_sde_key_list", "sender_sde_key_list")}
                menuStyle={{
                    width: 360
                }}
            />
            <CustomField
                accepter={CheckPicker}
                width={300}
                data={props.subdestinationList}
                virtualized
                labelKey="name"
                valueKey="sde_key"
                placeholder="Destinations"
                name={servicePick(service, "b_sde_key_list", "phone_sde_key_list")}
                menuStyle={{
                    width: 360
                }}
            />
            {/* <br /> */}
            {service ? <Text
                name="a_number"
                placeholder="A-Number"
                width={150}
                value={filters.a_number}
            /> : <CustomField
                accepter={Input}
                name="senderid"
                placeholder="Sender ID"
                width={150}
                value={filters.senderid}
            />}
            {!service ? <Text
                accepter={Input}
                placeholder="Message ID"
                width={300}
                name="message_id"
                value={filters.message_id}
            /> : <></>}
            {service ? <Text
                name="b_number"
                placeholder="B-Number"
                width={150}
                value={filters.b_number}
            /> : <Text
                name="phone"
                placeholder="Phone"
                width={150}
                value={filters.phone}
            />}
            {!service ? <>
                <Text
                    name="mcc_mnc"
                    placeholder="MCC/MNC"
                    width={130}
                    value={filters?.mcc_mnc}
                />
            </> : <></>}

            {!service ?
                <Checkbox
                    name="only_my_account"
                    onChange={(value, checked) => {
                        checkOnlyAccount(checked);
                    }}
                    defaultChecked={onlyMyAccountCheck}
                    style={{ width: 220, display: "inline-block" }}
                >
                    Show only my account traffic
                </Checkbox>
                : <></>}
            <Checkbox
                name="show_reliable"
                onChange={(_, checked) => checkReliability("show_reliable", checked)}
                checked={filters.show_reliable}
                style={{ width: 130, display: "inline-block" }}
            >
                Show trusted
            </Checkbox>
            <Checkbox
                name="show_not_reliable"
                onChange={(_, checked) => checkReliability("show_not_reliable", checked)}
                checked={filters.show_not_reliable}
                style={{ width: 145, display: "inline-block" }}
            >
                Show untrusted
            </Checkbox>
        </>;

        const mdrFailedFilters = <>
            <DateTimeRangePicker
                onChange={(value) => {
                    handleChangeDateTime(value);
                }}
                defaultStartDate={defaultFilters?.range[0]}
                defaultEndDate={defaultFilters?.range[1]}
                startDate={filters.range[0]}
                endDate={filters.range[1]}
                showRanges
            />

            <Text
                name="operator"
                placeholder="Operator"
                width={150}
                value={filters.operator}
            />
            <CustomField
                accepter={CheckPicker}
                labelKey="name"
                valueKey="cntr_key"
                data={props.countryList}
                placeholder="Countries"
                name="cntr_key_list"
                width={200}
                menuStyle={{
                    width: 280
                }}
            />
            <CustomField
                accepter={CheckPicker}
                virtualized
                data={props.supplierList}
                onChange={(supplierIdList) => {
                    if (supplierIdList && supplierIdList.length === 1) {
                        const foundSupplier = props.supplierList.find(supplier => supplier.id === supplierIdList[0]);
                        setPickedSupplier(foundSupplier || null);
                    } else {

                        setPickedSupplier(null);
                    }
                }}
                labelKey="name"
                valueKey="id"
                placeholder="Suppliers"
                name="supplier_id_list"
                width={200}
                menuStyle={{
                    width: 320
                }}
            />
            {!service ? <CustomField
                accepter={CheckPicker}
                virtualized
                data={pickedSupplier?.supplier_trunk_list || []}
                onChange={(supplierTrunkIdList) => {
                    setPickedSupplierTrunkList(supplierTrunkIdList);
                }}
                value={pickedSupplierTrunkList}
                labelKey="name"
                valueKey="id"
                placeholder="Supplier trunks"
                name="supplier_trunk_id_list"
                width={200}
                searchable={false}
                disabled={!pickedSupplier}
            /> : <></>}
            <CustomField
                accepter={Input}
                name="senderid"
                placeholder="Sender ID"
                width={150}
                value={filters.senderid}
            />
            <Text
                name="mcc_mnc"
                placeholder="MCC/MNC"
                width={130}
                value={filters.mcc_mnc}
            />
            <CustomField
                accepter={CheckPicker}
                virtualized
                width={300}
                data={props.subdestinationList}
                labelKey="name"
                valueKey="sde_key"
                placeholder="Origins"
                name="sender_sde_key_list"
                menuStyle={{
                    width: 360
                }}
            />
            <CustomField
                accepter={CheckPicker}
                virtualized
                width={300}
                data={props.subdestinationList}
                labelKey="name"
                valueKey="sde_key"
                placeholder="Destinations"
                name="phone_sde_key_list"
                menuStyle={{
                    width: 360
                }}
            />
            <Text
                name="phone"
                placeholder="Phone"
                width={200}
                value={filters.phone}
            />
            <CustomField
                accepter={CheckPicker}
                width={300}
                data={reasonList}
                labelKey="name"
                valueKey="key"
                placeholder="Reasons"
                name="reason_list"
                menuStyle={{
                    width: 320
                }}
            />
            {!service ?
                <Checkbox
                    name="only_my_account"
                    onChange={(value, checked) => {
                        checkOnlyAccount(checked);
                    }}
                    defaultChecked={onlyMyAccountCheck}
                    style={{ width: 220, display: "inline-block" }}
                >
                    Show only my account traffic
                </Checkbox>
                : <></>}
        </>;

        const currentFilters = isFailedMdr ? mdrFailedFilters : cdrMdrFilters;
        setCurrentFilters(currentFilters);
    }, [filters, secondUpdateFixer, pickedSupplier, props.supplierList, props.dialerList, props.subdestinationList, props.reasonList]);

    return (
        <>
            <Form
                layout="inline"
                onChange={handleChange}
                formDefaultValue={defaultFilters}
                formValue={filters}
            >
                {currentFilters}
                <FormGroupRight>
                    <ButtonPrimary
                        style={{ padding: "8px 34px", marginLeft: 12 }}
                        onClick={handleApply}
                        disabled={loading}
                    >
                        Apply filter
                    </ButtonPrimary>
                </FormGroupRight>
            </Form>
        </>
    );
};

const mapStateToProps = ({ references, cdr, auth }) => ({
    loading: cdr.loading,
    service: auth.service,
    originatorList: references.client_list,
    reasonList: references["sms.reason_list"],
    countryList: references["country_list"],
    dialerList: auth.service ? references.dialer_list : references["sms.dialer_list"],
    supplierList: auth.service ? references.supplier_list : references["sms.supplier_list"],
    subdestinationList: references.subdestination_list,
});

const mapDispatchToProps = {
    getReferencesForReports
};

export default connect(mapStateToProps, mapDispatchToProps)(FormHOC(CDRFilters));

const FormGroupRight = styled(Form.Group)`
    && {
        float: right;
        right: 0;
        margin-right: 0;
    }
`;
